import * as React from "react";
import {createTheme, styled, ThemeProvider} from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import {Outlet, useNavigate} from "react-router-dom";
import {AppBarProps as MuiAppBarProps} from "@mui/material/AppBar/AppBar";
import MuiAppBar from "@mui/material/AppBar";
import {Badge, Button, Paper} from "@mui/material";
import {AccountCircle, Login, Home as HomeIcon} from "@mui/icons-material";
import {TimezoneProvider} from "./contexts/TimezoneContext";
import {useSession} from "./contexts/SessionContext";
import {AppBreadcrumbs} from "./components/AppBreadcrumbs";

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © Dennis Fusaro'}
            {' 2023 - '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const drawerWidth: number = 240;

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `100%`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));


// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();//createTheme(getLPTheme("light"));

export default function Home() {
    const [open, setOpen] = React.useState(true);
    const {authenticated, authorized, user} = useSession()
    const timezone = user?.timezone ?? 'America/New_York'

    const navigate = useNavigate();
    const toggleDrawer = () => {
        setOpen(!open);
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Box sx={{display: 'flex'}}>
                <CssBaseline/>
                <AppBar position="absolute" open={open}>
                    <Toolbar
                    >
                        <IconButton color="inherit" component={Button} onClick={() => navigate("/")}>
                            <Badge color="secondary">
                                <HomeIcon/>
                            </Badge>
                        </IconButton>
                        <Typography
                            component="h1"
                            variant="h6"
                            color="inherit"
                            noWrap
                            sx={{flexGrow: 1}}
                        >
                            Alliance Massachusetts Web Tools
                        </Typography>
                        {authenticated
                            ? <IconButton color="inherit" component={Button} onClick={() => navigate("/settings")}>
                                <AccountCircle/>
                            </IconButton>
                            : <IconButton color="inherit" component={Button} onClick={() => { window.location.href = "/auth/login"; }}>
                                <Badge color="secondary"><Login/></Badge>
                            </IconButton>
                        }
                    </Toolbar>
                </AppBar>
                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}
                >
                    <Toolbar/>
                    {authorized && <AppBreadcrumbs/>}
                    <Box sx={{p: 2}}>
                    {(!authenticated) ? (<Paper elevation={2} sx={{height:50,p:2}}><Typography>Please Login To Use this
                        application.</Typography></Paper>) : null}
                    {(authorized) ? (<TimezoneProvider timezone={timezone}><Outlet/></TimezoneProvider>) : null}
                </Box>

                    <Container maxWidth="lg" sx={{mt: 4, mb: 4}}>
                        <Copyright sx={{pt: 4}}/>
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
}